export default __webpack_public_path__ + "static/media/SmartSplitter.64.f5c0b9f8.png";